import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import { identity } from 'lodash-es';
export default function onlyIf(condition) {
    return branch(function (props) { return condition(props); }, identity, renderNothing);
}
